import React, { useState } from "react";
import { API_BASE_URL, API_KEY, CAREER_ENDPOINT } from "../config";

const initialFormState = {
  name: "",
  email: "",
  mobile: "",
  resume: null,
  remarks: "",
};

export const Careers = (props) => {
  const [formData, setFormData] = useState(initialFormState);
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData((prev) => ({ ...prev, resume: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const clearForm = () => setFormData({ ...initialFormState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobile", formData.mobile);
    formDataToSend.append("remarks", formData.remarks);
    formDataToSend.append("resume", formData.resume);

    try {
      const response = await fetch(`${API_BASE_URL}${CAREER_ENDPOINT}`, {
        method: "POST",
        headers: { 
          "X-API-KEY": API_KEY   
        },
        body: formDataToSend,     // FormData
      });

      const result = await response.json();

      if (result.success) {
        setStatus("Application submitted successfully!");
        clearForm();
      } else {
        setStatus("Failed to send application.");
      }
    } catch (error) {
      console.error(error);
      setStatus("Failed to submit application.");
    }

  };


  return (
    <div id="careers">      
      <div className="container">
        <div className="col-xs-12 col-md-6" style={{ marginBottom: "30px" }}>
          <div className="row">
            {/* Career Info & List */}
            <div className="careers-text">
              <h1>Careers</h1>
              <p>
                {props.data ? props.data.paragraph : "loading..."}
              </p>
              <div className="careers-text">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.career_1.map((d, i) => <li key={`${d}-${i}`}>{d}</li>)
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.career_2.map((d, i) => <li key={`${d}-${i}`}>{d}</li>)
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>            
          </div>
        </div>

        {/* Career Form */}
        <div className="col-xs-12 col-md-6" style={{ marginBottom: "30px" }}>
          <h3>Apply for Internship / Job</h3>
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="form-group">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Name"
                required
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <input
                type="tel"
                name="mobile"
                className="form-control"
                placeholder="Mobile"
                required
                value={formData.mobile}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Resume (PDF/DOC)</label>
              <input
                type="file"
                name="resume"
                className="form-control"
                accept=".pdf,.doc,.docx"
                required
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <textarea
                name="remarks"
                className="form-control"
                rows="4"
                placeholder="Remarks"
                value={formData.remarks}
                onChange={handleChange}
              />
            </div>

            <div id="status" style={{ marginBottom: "10px", color: "green" }}>
              {status}
            </div>

            <button type="submit" className="btn btn-custom btn-lg">
              Submit Application
            </button>
          </form>
        </div>
        
        {/* Optional image */}
        <div className="row">
          <div className="col-xs-12">
            <img src="img/about.jpg" className="img-responsive" alt="Careers" />
          </div>
        </div>        
      </div>
    </div>
  );
};
